export default "__VITE_ASSET__BWTFtP7G__"